<template>
  <section class="view">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
          {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                Click Add Inspection Item and select the items you want, then click Save. Drag an Item to move it up or down.
            </p>
        </div>

        <div class="bar-container mb-2">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="template_items.length">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <UploadOptions
                    :ref="'file_excel_inspection_items'"
                    :empty_format_data="empty_format_data_inspection_items"
                    :excel_file_headers="excel_file_headers_inspection_items"
                    :file_name="'inspection_items_inspection_template_upload_template_file'"
                    :btn_label="'Upload options'"
                    id="file_excel_input_inspection_items"
                    @data="uploadInspectionItems($event)"
                    v-if="hasPermissions(['QC-Inspection-Template Inspection-Items-Upload'])"
                />
                <button v-if="hasPermissions(['QC-Inspection-Template Write'])" class="modal__buttons__item w-auto mr-md-auto ml-sm-2 px-3 ml-md-2" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>
            <div class="bar-container__cta" v-if="hasPermissions(['QC-Inspection-Template Write'])">
                <span class="button__modal text-righ">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>
        <div class="formdynamic__item col-md-3 mb-4" style="margin-top: 5px;">
            <div class="formdynamic__item__field">
                <label for="Name:" class="modal-label active">View Inspection Items on the date: </label>
                <input type="datetime-local" v-model="date_time"/>
            </div>
        </div>
        <div class="tab-content" v-show="template_items.length">
            <div class="tab-pane fade active show" id="listation">
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col" style="border-bottom: none">
                                    <span class="custom-control custom-checkbox">
                                        <input :id="'theadcheck'" v-model="select_all" type="checkbox" class="custom-control-input"/>
                                        <label :for="'theadcheck'" class="custom-control-label ml-2"/>
                                    </span>
                                </th>
                                <th style="border-bottom: none" v-html="'#'"/>
                                <th style="border-bottom: none" v-html="'Name'"/>
                            </tr>
                        </thead>
                        <draggable v-model="template_items" tag="tbody" :multi-drag="true" group="people" @start="drag=true" @end="drag=false" @change="orderRequest()" ghost-class="drag-ghost" :disabled="date_time ? true : false">
                            <tr v-for="(item, i) in display_items" :key="i">
                                <td>
                                    <span class="custom-control custom-checkbox">
                                        <input :id="`item${i}`" v-model="item.checked" type="checkbox" class="custom-control-input"/>
                                        <label :for="`item${i}`" class="custom-control-label ml-2"/>
                                    </span>
                                </td>   
                                <td v-html="i + 1"/>
                                <td v-html="item.name"/>
                            </tr>
                        </draggable>
                    </table>
                </div>
            </div>
        </div>

        <DeletionModal 
            :single_object="single_object" 
            :global_index="global_index" 
            @objectDeletion="object_deletion_child(rest_api, $event)"
        />

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
            :message="`The selected item(s) will be disassociated from the inspection template.`"
        />

        <FormModal 
            :title="'Inspection Items'"
            :breadcrumb="breadcrumb"
            :parent_id="parent_id"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :template_items="template_items"
            :array_options="array_options"
            @unshiftObject="unshift_object($event)"
            ref="form_modal"
        />

        <UploadSummary
          :breadcrumb="breadcrumb"
          :summary="summary"
          :excel_file_headers="summary_headers"
          :excel_data="excel_data"
          :file_name="name_summary_file"
        />


        <WaitingModal/>

    </section>
</template>

<script>

import axios            from    'axios';
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal     from    '@/components/WaitingModal'
import Resources        from    './detail_resources'
import ParentResources  from    '../resources'
import FormModal        from    './FormModal'
import DeletionModal    from    '@/components/DeletionModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import UploadSummary            from    '@/components/UploadSummary'
import UploadOptions            from    '@/components/UploadOptions'
import 'vuetify/dist/vuetify.min.css'
import draggable                from    'vuedraggable'

import { Notyf }            from    'notyf';
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'InspectionTemplateStep',

    components: {
      Breadcrumb,
      WaitingModal,
      DeletionModal,
      DeletionMassiveModal,
      FormModal,
      draggable,
      UploadOptions,
      UploadSummary
     },

     data() {
        return {
          notyf,
          axios,
          room_qc_inventory_id:   this.$route.params.id,
          child_href:             `/qc-inspection-template/${this.room_qc_inventory_id}`,
          parent:                 {},
          parent_id:              '',
          title_page:             'Associated Inspection Items',
          rest_api_parent:        `inspection_templates/${this.$route.params.id}`,
          single_rest_api_parent:        `inspection_templates`,
          rest_api:               `inspection_template_codes`,
          table_headers:          Resources.table_headers,
          breadcrumb:             Resources.breadcrumb,
          excel_file_headers_inspection_items:  ParentResources.excel_file_headers_inspection_items,
          empty_format_data_inspection_items:   ParentResources.empty_format_data_inspection_items,
          add_btn:                'Add Inspection Item',
          single_select:          false,
          table_selection:        [],
          search:                 '',
          global_index:           null,
          single_object:          {},
          template_items:         [],
          select_ids:             [],
          array_options:          {
            master_step_code_id:        [],
            room_qc_inventory_item_id:  []
          },
          select_all: false,
          summary_headers:                null,
          summary:                        [],
          excel_data:                     [],
          name_summary_file:              'inspection_templates_failed_template_file',
          first_filled_data: false,
          date_time: '',
          debounceTimer: undefined
        }
    },

    watch:{
        async 'select_all'(val)
        {
            this.display_items.map(item => item.checked = val)
        },
        
        async 'date_time'(val)
        {
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }

            this.debounceTimer = setTimeout(async () => {
                await this.api_request(`${this.rest_api_parent}?date_time=${val}`);
            }, 800); // 500 milliseconds = 0.5 seconds
        }
    },

    methods: {

        async orderRequest()
        {
            this.loader(true)
            const response = await this.put(`${this.rest_api}/${this.parent.decrypted_id}`, {master_step_code_id: this.template_items})
            this.loader()

            if(response.status)
            {
                this.notyfMesg('Order was updated')
            }
        },

        unshift_object(new_object)
        {
            new_object.forEach(item => 
            {
                this.template_items.unshift(item)
            })
        },

        form_modal()
        {
            this.array_options.master_step_code_id.forEach(value => value.checked = false)
            window.$('#static').modal('show')
        },

        massive_modal_delete()
        {
            this.select_ids = this.template_items.filter(item => item.checked).map(item => item.id)
            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let sendingMassive = await this.massive_delete({ ids: this.select_ids })

            if(sendingMassive)
            {
                this.select_ids.forEach( item =>
                {
                    const index = this.template_items.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.template_items.splice(index, 1)
                    }
                })
                this.select_ids = []
            }
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.template_items[index]
            window.$('#static-deletion').modal('show')
        },


        fill_data(data)
        {
            if(!this.first_filled_data)
            {
                this.parent               = data.parent
                this.parent_id            = data.parent_id
                this.array_options        = {
                    master_step_code_id: data.master_step_codes,
                    room_qc_inventory_item_id: data.qc_inventories_items
                }
                this.breadcrumb.push({
                    name:   this.parent.name,
                    href:   '#',
                    arrow:  "",
                })
            }

            this.first_filled_data = true

            this.template_items = data.template_items
        },

        async uploadInspectionItems(data)
        {
            this.excel_data = data

            this.loader(true)
            const response = await this.post(`${this.single_rest_api_parent}/massive_inspection_items`, { items: this.excel_data, timestamp: this.getCurrentDateTime() })
            this.loader()

            if(response.status)
            {
                if(response.data.is_queue)
                {
                    notyf.success('Given you are uploading many records, you will get notified when the upload process is finished.')
                    return;
                }

                notyf.success('Success!')
                this.summary_headers = this.excel_file_headers_inspection_items
                this.summary = response.data.summary
                this.name_summary_file = 'inspection_items_inspection_template_failed_template_file'
                window.$('#upload-summary').modal('show')
            }
            else
            {
                this.error_handling(response)
            }

            this.api_request(this.rest_api_parent)

            this.$refs.file_excel_inspection_items.clear_data()
        },

        trashing(index)
        {
            this.template_items.splice(index, 1)
        },

    },

    async mounted()
    {
        if(this.hasPermissions(['QC-Inspection-Template Read']))
        {
            await this.api_request(this.rest_api_parent)
        }
        else
        {
            window.location = '/'
        }
    },

     computed:
    {
        selected()
        {
            const bool = this.display_items.filter(item => item.checked)
            return Boolean(bool.length)
        },

        display_items()
        {
            if(this.search)
            {
                return this.template_items.filter(item => item.name.toLowerCase().includes(this.search.toLowerCase()))
            }
            return this.template_items
        }
    },
}
</script>